import React, {FC, useMemo} from 'react';
import {Navigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import routes, {getRoute} from '~/route-map';
import useEffectOnce from '~/hooks/use-effect-once';
import {actions} from '~/state/reducers/current-user-reducer';
import Selectors from "~/state/selectors.ts";

export const TnAdminRedirect: FC = () => {
    const cnum = useSelector(Selectors.getCustomerNumber);
    const ctx = useSelector(Selectors.getAppContext);
    const isTnUser = useSelector(Selectors.isTnUser);
    const dispatch = useDispatch();

    const homeUrl = useMemo<string>(
        () => getRoute(routes.app.base, {cnum, ctx}),
        [cnum, ctx]
    );

    useEffectOnce(() => {
        dispatch(actions.setTnUser(true));
    });

    if (!isTnUser) {
        return null;
    }

    return (<Navigate to={homeUrl} replace />);
};

export default TnAdminRedirect;